import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useSelector } from 'react-redux'

/**
 * Whether the current user can reach /demo-company-management.
 *
 * Mirrors the two independent gates on the section: the platform-admin role
 * check in DemoCompanyManagement.route.ts, and the flag check in
 * DemoCompanyGate, which redirects to Home.
 *
 * Callers outside the section use this before linking into it — sending a user
 * somewhere they'll be bounced from is worse than leaving them where they are.
 */
export default function useCanAccessDemoCompanies(): boolean {
  const { flags } = useFeatureFlags()
  const role = useSelector(authSelectors.getRole)

  return (
    role === ROLE_PLATFORM_HIXME_ADMIN &&
    Boolean(flags['admin.customers.demo-management-enabled'])
  )
}
